import React from 'react';
import moment from 'moment';

import { observer } from 'src/utils/mobx-react';
import { getCurrency } from 'src/AppState/sdk/staff';
import { OpenapiProxyStaffAllTransactionsGetListResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_all_transactions_get_list';
import { Amount } from 'src_common/common/amount/Amount';
import { DateTime } from 'src_common/utils/time/time';
import { TableData } from './WithdrawalHistory.style';

type WithdrawalHistoryPropsType = {
    withdrawalsList: OpenapiProxyStaffAllTransactionsGetListResponse200Type | null;
};

const formatCardDetails = (cardNumber: string | undefined | null, expires: string | undefined | null): string => {
    const card = cardNumber ?? null;
    const cardExpires = expires ?? null;

    if (card === null) {
        return '-';
    }

    if (cardExpires === null) {
        return card;
    }

    const formatedCardExpires = DateTime.from(cardExpires)?.format('MM/YY');
    if (formatedCardExpires === undefined) {
        return card;
    }

    return `${card}, ${formatedCardExpires}`;
};

export const WithdrawalHistory = observer('WithdrawalHistory', ({ withdrawalsList }: WithdrawalHistoryPropsType) => (
    <table>
        <thead>
            <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Payment details</th>
                <th>Status</th>
            </tr>
        </thead>
        <tbody>
            {withdrawalsList?.results.map(({ amount, id, currency, type, createdAt, details, status }) => {
                const convertedAmount = type === 'withdrawal' ? new Amount(amount).multiply(-1) : new Amount(amount);
                return (
                    <tr key={id}>
                        <td>{moment(createdAt).format('YYYY-MM-DD')}</td>
                        <TableData isLessThanZero={convertedAmount.isLessThanZero()}>
                            {convertedAmount.format(getCurrency(currency))}
                        </TableData>
                        <td>{formatCardDetails(details.paymentMethod?.name, details.paymentMethod?.expires)}</td>
                        <td>{status}</td>
                    </tr>
                );
            })}
        </tbody>
    </table>
));
